export default __webpack_public_path__ + "static/media/badge.2c1da928.svg";